import API from 'js/lib/api';

const feedbackAdminAPI = API('/api/feedbackAdmin.v1', {
  type: 'rest',
});

export default feedbackAdminAPI;
